export default __webpack_public_path__ + "static/media/wetland_hero.6a125217.jpg";